import React from 'react';
import PropTypes from 'prop-types';
import MainTextField from '../MainTextField';
import TextMaskCustom from '../TextMaskCustom';

const TimePicker = (props) => (
  <MainTextField
    {...props}
    InputProps={{
      inputComponent: TextMaskCustom,
      inputProps: {
        handler: 'timeMask',
      },
    }}
  />
);

TimePicker.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  format: PropTypes.string,
  value: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

TimePicker.defaultProps = {
  label: '',
  placeholder: '',
  format: 'HH:mm',
  variant: 'outlined',
  value: '',
  size: 'small',
};

export default TimePicker;
